<script lang="ts">
  import { selectAreas } from "$lib/utils/areaUtils";
  import sessionValues from "$lib/sessionValues";
  import { page } from "$app/state";
  import { browser } from "$app/environment";

  const getStoredArea = (): string | undefined => {
    const urlArea = page?.url?.hash?.slice(1) || undefined;
    if (urlArea) return urlArea;
    const storageArea = $sessionValues?.i;
    if (storageArea) return storageArea;
  };

  let {
    selectedArea = $bindable(),
    selectedAreas = $bindable(),
    initArea,
    useAreaColors = false,
    class: classes = "",
    selectedPrices,
  }: {
    selectedArea?: string;
    selectedAreas?: string[];
    initArea?: string;
    class?: string;
    useAreaColors?: boolean;
    selectedPrices?: Map<string, number>;
  } = $props();

  if (initArea) {
    selectedArea = initArea;
  }

  if (browser) {
    const storedSelectedArea = getStoredArea();
    if (storedSelectedArea) selectedArea = storedSelectedArea;
  }
</script>

<ul class="p-0 list-none {classes}" class:area-colors={useAreaColors}>
  {#each selectAreas as area (area.urlLabel)}
    {@const id = `omradevalg-${area.urlLabel}`}

    <li
      class="relative"
      style={`--area-line-color: var(--${area.value.toLowerCase()}-line-color);`}
    >
      <p class="my-0 inline">
        <label
          for={id}
          class="button button-link border-0 rounded-0 px-1 min-w-[3rem] active:no-underline relative pt-0 pb-1 min-h-48px leading-tight inline-grid content-end"
        >
          <span class="tablet:hidden">
            {area.shortLabel}
          </span>
          <span class="hidden tablet:inline">
            {area.label}
          </span>
          <small class="font-normal block">
            {area.value}
          </small>
          <input
            type="checkbox"
            {id}
            name="omradevalg"
            value={area.urlLabel}
            bind:group={selectedAreas}
          />
        </label>
      </p>

      {#if selectedPrices && selectedPrices.has(area.value) && (!selectedAreas || selectedAreas.includes(area.urlLabel))}
        <p
          class="m-0 absolute left-0 bottom-[calc(-1*var(--s-5))] w-full text-center font-bold text-sm"
        >
          {selectedPrices.get(area.value)}
        </p>
      {/if}
    </li>
  {/each}
</ul>

<style lang="postcss">
  :where(ul) :where(:global(input[type="checkbox"], input[type="radio"])) {
    all: unset;
    position: absolute;
    inset: 0;

    &:focus-visible {
      outline: 3px solid var(--focus);
    }
  }

  label.button {
    box-shadow:
      0 1px var(--glod),
      0 3px color-mix(in oklab, black 12.5%, transparent);
    color: var(--fg-muted);

    &:has(:global(:checked)) {
      box-shadow: inset 0 -3px var(--area-line-color, var(--primary-strong));
      color: var(--fg);
    }
  }
</style>
